import request from '@/utils/request';
const Qs = require('qs');
// import httpUtil from "@/utils/httpUtil";

//状态
export function getStatus(params) {
  return request({
    url: '/website/auth/status',
    method: 'get'
  });
}

//退出
export function getLogout(params) {
  return request({
    url: '/auth/logout',
    method: 'delete',
    data: params
  });
}


//注册
export function getRegister(params) {
  return request({
    url: '/website/auth/register',
    method: 'post',
    data: params
  });
}

//登录
export function getLogin(params) {
  return request({
    url: '/login',
    method: 'post',
    data: params
  });
}


//查询

export function getHandleList(params) {
  return request({
    url: '/api/dataMonitor/handleInfo?' + Qs.stringify(params),
    method: 'get'
  })
}

// 解决方案列表
export function getJJFAData(params) {
  return request({
    url: '/api/website/solution?' + Qs.stringify(params),
    method: 'get'
  })
}

// 解决方案列表
export function solutionById(params) {
  return request({
    url: '/api/website/solutionById?' + Qs.stringify(params),
    method: 'get'
  });
}

// 友情链接
export function getLinkData(params) {
  return request({
    url: '/api/website/links',
    method: 'get'
  })
}

// 政策支持

export function getArticleData(params) {
  return request({
    url: '/api/website/article?' + Qs.stringify(params),
    method: 'get'
  })
}

export function articleById(params) {
  return request({
    url: '/api/website/articleById?' + Qs.stringify(params),
    method: 'get'
  })
}

// 应用市场
export function getApplicationData(params) {
  return request({
    url: '/api/website/application?' + Qs.stringify(params),
    method: 'get'
  })
}
// 应用市场详情
export function fetchAplicationById(params) {
  return request({
    url: '/api/website/applicationById?' + Qs.stringify(params),
    method: 'get'
  })
}

// 申请
export function fetchApplicationApply(params) {
  return request({
    url: '/api/website/applicationApply',
    method: 'post',
    data: params
  })
}

// 网站基本信息
export function fetchWebsiteInfo(params) {
  return request({
    url: '/api/website/websiteInfo',
    method: 'get'
  })
}

//查询内容信息
export function contentByType(params) {
  return request({
    url: '/api/website/contentByType?' + Qs.stringify(params),
    method: 'get'
  })
}

//查询行业分类
export function categoryList(params) {
  return request({
    url: '/api/platform/categoryList?' + Qs.stringify(params),
    method: 'get'
  })
}

//供需列表
export function supplyDemandList(params) {
  return request({
    url: '/api/platform/supplyDemandList?' + Qs.stringify(params),
    method: 'get'
  })
}

//供需发布
export function publish(params) {
  return request({
    url: '/api/platform/publish',
    method: 'post',
    data: params
  })
}

//供需列表详情
export function supplyDemandById(params) {
  return request({
    url: '/api/platform/supplyDemandById?' + Qs.stringify(params),
    method: 'get'
  })
}

//供需列表详情
export function reserve(params) {
  return request({
    url: '/api/platform/reserve',
    method: 'post',
    data: params
  })
}

//留言列表
export function reserveMessageList(params) {
  return request({
    url: '/api/platform/reserveMessageList?' + Qs.stringify(params),
    method: 'get'
  })
}

// 填写需求
export function fetchAddNeed(params) {
  return request({
    url: '/api/platform/openDemandSubmit',
    method: 'post',
    data: params
  })
}

// 用户应用列表
export function fetchUserAppList(params) {
  return request({
    url: '/api/console/userApplicationList?' + Qs.stringify(params),
    method: 'get'
  })
}

//查询用户信息
export function userInfo() {
  return request({
    url: '/website/user/userInfo',
    method: 'get'
  })
}

//修改用户信息
export function updateUser(params) {
  return request({
    url: '/website/user/updateUser',
    method: 'post',
    data: params
  })
}

//查询用户参与供需列表
export function UserParticipateList(params) {
  return request({
    url: '/api/console/UserParticipateList?' + Qs.stringify(params),
    method: 'get'
  })
}

//查询用户供需列表
export function UserSupplyDemandList(params) {
  return request({
    url: '/api/console/userSupplyDemandList?' + Qs.stringify(params),
    method: 'get'
  })
}

//查询用户提交开放需求列表
export function UserOpenDemandList(params) {
  return request({
    url: '/api/console/userOpenDemandList?' + Qs.stringify(params),
    method: 'get'
  })
}

// 服务需求
export function fetchServeList(params) {
  return request({
    url: '/api/console/userOpenDemandList?'+Qs.stringify(params),
    method: 'get'
  })
}

// 获取用户信息
export function fetchUserData () {
  return request({
    url: '/website/user/userInfo',
    method: 'get'
  })
}

// 接口服务列表
export function fetchApiList () {
  return request({
    url: '/api/console/userInterfaceList',
    method: 'get'
  })
}

// 接口服务详情
export function fetchApiDetail (params) {
  return request({
    url: '/api/console/findInterfaceById?'+Qs.stringify(params),
    method: 'get'
  })
}

// 修改密码
export function fetchChangePass (params) {
  return request({
    url: '/website/user/updatePass',
    method: 'post',
    data: params
  })
}

// 查询生态与合作内容
export function ecology (params) {
  return request({
    url: '/api/website/ecology',
    method: 'get'
  })
}

// 查询应用分类
export function fetchAllCategory () {
  return request({
    url: '/api/website/appArrangeList',
    method: 'get'
  })
}

// 根据分类查询应用 前台
export function fetchAllAppByFL (params) {
  return request({
    url: '/api/website/application?'+Qs.stringify(params),
    method: 'get'
  })
}

// 控制台
export function fetchAllAppByFL2 (params) {
  return request({
    url: '/api/console/application?'+Qs.stringify(params),
    method: 'get'
  })
}

// 控制台解决方案列表
export function fetchPlanList (params) {
  return request({
    url: '/api/console/userSolutionList?'+Qs.stringify(params),
    method: 'get'
  })
}

// 控制台解决方案编辑
export function fetchPlanEdit (params) {
  return request({
    url: '/api/console/solutionEdit',
    method: 'post',
    data: params
  })
}

// 控制台解决方案添加
export function fetchPlanAdd (params) {
  return request({
    url: '/api/console/solutionSubmit',
    method: 'post',
    data: params
  })
}

// 控制台解决方案删除
export function fetchPlanDelete (params) {
  return request({
    url: '/api/console/solutionDel',
    method: 'delete',
    data: params
  })
}

// 授权应用列表
export function fetchMyApp(params) {
  return request({
    url: '/api/console/authorisationList?'+Qs.stringify(params),
    method: 'get'
  })
}
// 管理应用列表
export function fetchManageAppList(params) {
  return request({
    url: '/api/console/userSubmitApplicationList?'+Qs.stringify(params),
    method: 'get'
  })
}

// 新增应用
export function fetchAddApp (params) {
  return request({
    url: '/api/console/applicationSubmit',
    method: 'post',
    data: params
  })
}
// 编辑应用
export function fetchEditApp (params) {
  return request({
    url: '/api/console/applicationEdit',
    method: 'post',
    data: params
  })
}
// 删除应用
export function fetchDeleteApp(params) {
  return request({
    url: '/api/console/applicationDel?'+Qs.stringify(params),
    method: 'get'
  })
}

// 标识解析查询内容
export function fetchIntroduceByType(params) {
  return request({
    url: '/api/website/introduceByType?'+Qs.stringify(params),
    method: 'get'
  })
}

// 接口市场，获取类型
export function fetchInterfaceTypeList() {
  return request({
    url: '/api/platform/interfaceTypeList',
    method: 'get'
  })
}
// 接口市场，查询列表
export function fetchInterfaceList(params) {
  return request({
    url: '/api/platform/interfaceList?'+Qs.stringify(params),
    method: 'get'
  })
}
// 接口市场，接口申请
export function fetchInterfaceApply(params) {
  return request({
    url: '/api/platform/interfaceApply',
    method: 'post',
    data: params
  })
}

// IOT平台
export function fetchIotIntroduce() {
  return request({
    url: '/api/console/iotIntroduce',
    method: 'get'
  })
}

// 删除用户供需
export function fetchDelSupplyDemand(params) {
  return request({
    url: '/api/console/delUserSupplyDemand?'+Qs.stringify(params),
    method: 'get'
  })
}
//企业节点
export function nodeEjjdList(params) {
  return request({
    url: '/api/website/nodeEjjdList?'+Qs.stringify(params),
    method: 'get'
  })
}

// 控制台IOT菜单权限

export function fetchIotMenu() {
  return request({
    url: '/website/user/userInfo',
    method: 'get'
  })
}


// 授权应用页面同步
export function fetchAuthAppRegister(params) {
  return request({
    url: '/api/console/authSyncRegister',
    method: 'post',
    data: params
  })
}

// 应用管理页面同步
export function fetchMarAppRegister(params) {
  return request({
    url: '/api/console/syncRegister',
    method: 'post',
    data: params
  })
}

//根据二级节点id查询企业节点列表
export function nodeCompanyList(params) {
  return request({
    url: '/api/website/nodeCompanyList?'+Qs.stringify(params),
    method: 'get'
  })
}

// 节点代理商列表
export function nodeAgentList(params) {
  return request({
    url: '/api/website/nodeAgentList',
    method: 'get'
  })
}

//用户绑定的应用程序的账号
export function authBind(params) {
  return request({
    url: '/api/console/authBind?'+Qs.stringify(params),
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/api.js